import axios from 'axios'
import router from '../router'

const http = axios.create({ timeout: 20000 })

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

function clearAuth() {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_name')
  if (router.currentRoute.path !== '/login') {
    router.replace('/login')
  }
}

http.interceptors.response.use((res) => {
  const data = res.data
  if (data && data.code === 0) {
    return data.data
  }
  if (data && data.code === 401) {
    clearAuth()
  }
  return Promise.reject(new Error(data && data.message ? data.message : '请求失败'))
}, (err) => {
  const msg = (err.response && err.response.data && err.response.data.message) || err.message || '网络错误'
  if (err.response && err.response.status === 401) {
    clearAuth()
  }
  return Promise.reject(new Error(msg))
})

export function login(payload) {
  return http.post('/api/admin/login', payload)
}

export function changePassword(payload) {
  return http.post('/api/admin/password', payload)
}

export function clearBusinessData() {
  return http.post('/api/admin/data/clear', null, { timeout: 60000 })
}

export function users(params) {
  return http.get('/api/admin/users', { params })
}

export function usersAll(keyword) {
  return http.get('/api/admin/users/all', { params: { keyword } })
}

export function createUser(payload) {
  return http.post('/api/admin/users', payload)
}

export function generateInviteUser() {
  return http.post('/api/admin/users/invite')
}

export function unbindDevice(id) {
  return http.post('/api/admin/users/' + id + '/unbind-device')
}

export function updateUser(id, payload) {
  return http.put('/api/admin/users/' + id, payload)
}

export function deleteUser(id) {
  return http.delete('/api/admin/users/' + id)
}

export function score(id, payload) {
  return http.post('/api/admin/users/' + id + '/score', payload)
}

export function robot() {
  return http.get('/api/admin/users/robot')
}

export function rules(params) {
  return http.get('/api/admin/rules', { params })
}

export function rulesAll() {
  return http.get('/api/admin/rules/all')
}

export function ruleDetail(id) {
  return http.get('/api/admin/rules/' + id)
}

export function saveRule(payload) {
  return http.post('/api/admin/rules', payload)
}

export function deleteRule(id) {
  return http.delete('/api/admin/rules/' + id)
}

export function copyRule(id) {
  return http.post('/api/admin/rules/' + id + '/copy')
}

export function groups(params) {
  return http.get('/api/admin/groups', { params })
}

export function groupDetail(id) {
  return http.get('/api/admin/groups/' + id)
}

export function saveGroup(payload) {
  return http.post('/api/admin/groups', payload)
}

export function deleteGroup(id) {
  return http.delete('/api/admin/groups/' + id)
}

export function setDefaultGroup(id, isDefault) {
  return http.post('/api/admin/groups/' + id + '/default', { isDefault: !!isDefault })
}

export function setGroupClosed(id, closed) {
  return http.post('/api/admin/groups/' + id + '/close', { closed: !!closed })
}

export function addMembers(id, userIds) {
  return http.post('/api/admin/groups/' + id + '/members', { userIds })
}

export function removeMember(id, userId) {
  return http.delete('/api/admin/groups/' + id + '/members/' + userId)
}

export function funds(params) {
  return http.get('/api/admin/funds', { params })
}

export function fundStats(params) {
  return http.get('/api/admin/funds/stats', { params })
}

export function exportFundReport(params) {
  const token = localStorage.getItem('admin_token')
  return axios.get('/api/admin/funds/export', {
    params,
    responseType: 'blob',
    timeout: 120000,
    headers: token ? { Authorization: 'Bearer ' + token } : {}
  }).then((res) => {
    return parseBlobFilename(res).then((ok) => {
      const url = window.URL.createObjectURL(ok.blob)
      const a = document.createElement('a')
      a.href = url
      a.download = ok.filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    })
  }).catch((err) => {
    if (err.response && err.response.status === 401) {
      clearAuth()
    }
    if (err.response && err.response.data instanceof Blob) {
      return err.response.data.text().then((text) => {
        let msg = '导出失败'
        try {
          const json = JSON.parse(text)
          if (json && json.message) {
            msg = json.message
          }
        } catch (e) {
          // keep default
        }
        return Promise.reject(new Error(msg))
      })
    }
    return Promise.reject(new Error((err.response && err.response.data && err.response.data.message) || err.message || '导出失败'))
  })
}

function parseBlobFilename(res) {
  const type = (res.headers && res.headers['content-type']) || ''
  const blob = new Blob([res.data], {
    type: type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  if (type.indexOf('application/json') !== -1) {
    return blob.text().then((text) => {
      let msg = '导出失败'
      try {
        const json = JSON.parse(text)
        if (json && json.message) {
          msg = json.message
        }
      } catch (e) {
        // keep default
      }
      return Promise.reject(new Error(msg))
    })
  }
  let filename = '资金明细报表.xlsx'
  const disp = res.headers && res.headers['content-disposition']
  if (disp) {
    const star = disp.match(/filename\*=(?:UTF-8''|utf-8'')([^;]+)/i)
    const plain = disp.match(/filename="?([^";]+)"?/i)
    const raw = (star && star[1]) || (plain && plain[1])
    if (raw) {
      try {
        filename = decodeURIComponent(raw)
      } catch (e) {
        filename = raw
      }
    }
  }
  return Promise.resolve({ blob, filename })
}

export function upload(file, kind) {
  const fd = new FormData()
  fd.append('file', file)
  return http.post('/api/admin/upload', fd, {
    params: { kind: kind || 'file' },
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}
